<div
  class="kr-exchange__header"
  data-testid="exchange_crypto_fiat_header"
  [style.display]="!isPageOpened ? 'none' : null">
  <h4 class="kr-exchange__header-text" data-testid="exchange_crypto_fiat_title">
    {{ 'exchange.dialog.title' | translate }}
  </h4>

  <button
    class="kr-exchange__header-btn-close"
    data-testid="exchange_crypto_fiat_close_button"
    type="button"
    fuButton
    uiType="quaternary"
    size="m"
    [onlyIcon]="true"
    (click)="dialogRef.close()">
    <fu-icon
      iconName="close-square"
      data-testid="exchange_crypto_fiat_close_icon"></fu-icon>
  </button>
</div>

<div
  class="kr-exchange__body"
  data-testid="exchange_crypto_fiat_body"
  [style.padding]="!isPageOpened ? '0!important' : null">
  <div class="kr-exchange__content" data-testid="exchange_crypto_fiat_content">
    <fu-icon
      iconName="success"
      size="64"
      data-testid="exchange_crypto_fiat_success_icon" />

    <h5
      class="kr-success__message"
      data-testid="exchange_crypto_fiat_success_message"
      translate="exchange.dialog.success.title"></h5>

    <div class="kr-success__row" data-testid="exchange_crypto_fiat_row">
      <div
        class="kr-details"
        data-testid="exchange_crypto_fiat_transaction_id_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_transaction_id_label"
          translate="exchange.dialog.success.transactionID">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_transaction_id_value"
          (click)="clipboard.copy(store.exchange()?.operationId)">
          {{ store.exchange().operationId }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_transaction_id_copy_icon" />
        </span>
      </div>

      <div class="kr-details" data-testid="exchange_crypto_fiat_date_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_date_label"
          translate="exchange.dialog.success.date">
        </label>

        @let date = getDate() | date: 'dd MMM yyyy';
        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_date_value"
          (click)="clipboard.copy(date)">
          {{ date }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_date_copy_icon" />
        </span>
      </div>

      <div class="kr-details" data-testid="exchange_crypto_fiat_time_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_time_label"
          translate="exchange.dialog.success.time">
        </label>

        @let time = getDate() | date: 'HH:mm:ss';
        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_time_value"
          (click)="clipboard.copy(time)">
          {{ time }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_time_copy_icon" />
        </span>
      </div>
    </div>

    <div class="kr-success__grid" data-testid="exchange_crypto_fiat_grid">
      <div
        class="kr-details"
        data-testid="exchange_crypto_fiat_from_wallet_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_from_wallet_label"
          translate="exchange.dialog.fromWallet">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_from_wallet_value"
          (click)="clipboard.copy(walletFrom.address)">
          {{ walletFrom.address }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_from_wallet_copy_icon" />
        </span>
      </div>

      <div
        class="kr-details"
        data-testid="exchange_crypto_fiat_amount_from_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_amount_from_label"
          translate="exchange.dialog.amount">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_amount_from_value"
          (click)="
            clipboard.copy(
              estimation().totalValueToSend.amount.toString() +
                ' ' +
                estimation().totalValueToSend.symbol
            )
          ">
          {{
            estimation().totalValueToSend.amount.toString()
              | balanceFormat: estimation().totalValueToSend.symbol
          }}
          {{ estimation().totalValueToSend.symbol }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_amount_from_copy_icon" />
        </span>
      </div>

      <div
        class="kr-details"
        data-testid="exchange_crypto_fiat_to_wallet_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_to_wallet_label"
          translate="exchange.dialog.toWallet">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_to_wallet_value"
          (click)="clipboard.copy(form().value['iban'] ?? walletTo.address)">
          {{ form().value['iban'] ?? walletTo.address }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_to_wallet_copy_icon" />
        </span>
      </div>

      <div
        class="kr-details"
        data-testid="exchange_crypto_fiat_amount_to_receive_section">
        <label
          class="kr-details__label"
          data-testid="exchange_crypto_fiat_amount_to_receive_label"
          translate="exchange.dialog.amountToReceive">
        </label>

        <span
          class="kr-details__value kr-details__value_hover"
          data-testid="exchange_crypto_fiat_amount_to_receive_value"
          (click)="
            clipboard.copy(
              estimation().valueToReceive.amount.toString() +
                ' ' +
                estimation().valueToReceive.symbol
            )
          ">
          {{
            estimation().valueToReceive.amount.toString()
              | balanceFormat: estimation().valueToReceive.symbol
          }}
          {{ estimation().valueToReceive.symbol }}
          <fu-icon
            iconName="copy"
            size="16"
            data-testid="exchange_crypto_fiat_amount_to_receive_copy_icon" />
        </span>
      </div>
    </div>
  </div>
</div>
